<template>
  <!--  category search 组件实现  -->
  <div ref="componentsRoot" class="category-search" @click.stop>
    <div class="category-search-container">
        <!-- icon -->
        <div class="category-search-icon-container">
            <div class="category-search-icon" @click="searchInfo">
                <i class="el-icon-search"></i>
            </div>
        </div>
        <!-- category-search-main -->
        <div class="category-search-line-container">
            <el-scrollbar ref="lineScroll" style="height:100%" wrap-style="overflow-x:hidden;overflow-y:hidden;" >
                <ul class="category-search-line" >
                    <li class="category-search-tag-item" v-for="(result,key) in resultMap" :key="key" @click="clickTag($event,key)">
                        <div class="category-search-tag-container">
                            <span class="category-search-tag">
                                <span>{{result.tag}}</span>
                            </span>
                            <a class="category-search-tag-remove" @click="deleteTag(key)">
                                ×
                            </a>
                        </div>
                    </li>
                    <div class="category-search-input" ref="categorySearchInputDiv">
                        <div class="category-search-input-container">
                            <div style="width:100%">
                                <!--  -->
                                <input ref="keyWordInput" v-model="keyWord" @click="clickCategorySearchInput" placeholder="点击此处添加筛选条件" @input="closeAllCard" @keyup.enter="handleKeyWord"/>
                            </div>
                        </div>
                    </div>
                </ul>
            </el-scrollbar>
            
        </div>
    </div>
    <!-- conditions card -->
    <el-card :class="showConditionsCard ? 'conditions-card-show' : 'conditions-card-close'" :style="conditionsCardStyle">
        <div class="conditions-container">
            <el-scrollbar style="height:100%" wrap-style="overflow-x:hidden;overflow-y:hidden;">
                <div class="condition-item" v-for="(condition,key) in unSelectedConditionMap" :key="key" @click="chooseCondition(key,condition)">{{condition.label}}</div>
            </el-scrollbar>
        </div>
    </el-card>
    <!-- values check card-->
    <el-card :class="showValuesCheckCard ? 'values-check-card-show' : 'values-check-card-close'" :style="valuesCardStyle">
        <el-table
            ref="valuesCheckTable"
            :data="valuesCheckTableData"
            tooltip-effect="dark"
            style="width: 100%"
            max-height="210px"
            @select-all="selectAllValuesCheck"
            @select="selectValuesCheck">
            <el-table-column
            type="selection" width="50px">
            </el-table-column>
            <el-table-column
            :label="valuesCheckTableTitle"
            prop="label" width="120px" show-overflow-tooltip="false">
            </el-table-column>
        </el-table>
        <div style="margin-top: 15px">
            <el-button type="primary" size="mini" @click="confirmValues">确定</el-button>
            <el-button size="mini" @click="closeAllCard">取消</el-button>
        </div>
    </el-card>
  </div>
</template>

<script>
export default {
    name: 'CategorySearch',
    props: {//接受组件外部传参
        conditions: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            //要显示的内容是condition card还是value card
            //0为条件 1为值
            //主要用于input的点击事件的控制
            conditionOrValue: 0,
            //用于标记全局是否有card正在显示
            hasCardShowing: false,

            //样式控制
            //是否显示过滤条件Card
            showConditionsCard: false,
            //过滤条件Card样式
            conditionsCardStyle: {
                // top:'0px',
                left: '0px',//用于控制card水平位置
            },
            //是否显示value check card //check类型
            showValuesCheckCard: false,
            showingConditionKey: "", 
            changingConditionKey: "",
            valuesCheckTableTitle:"标题",
            //value check card 数据
            valuesCheckTableData: [],
            //所有的value card共用同一个样式
            valuesCardStyle: {
                left: "0px",//用于控制card水平位置
            },

            //过滤条件，此处为模拟
            conditionMap:this.conditions,
            //结果
            //结果集，map形式存储
            resultMap: {
                //最终版本应能够做到根据condition类型，处理成相应的结果
                // "typeId": {
                //     values:[],//选择的结果 列表
                //     tag:""//于页面中显示的tag
                // }
            },
            keyWord:""
        };
    },
    methods: {
        //点击input输入框
        clickCategorySearchInput(e) {
            //如果有card正在显示，关闭所有card
            if(this.hasCardShowing) {
                this.closeAllCard();
            } else {
                //应当展示的是condition card
                if(this.conditionOrValue === 0) {
                    //显示条件card
                    this.showConditions(e);
                } else {
                    //定位
                    let targetRect = e.target.getBoundingClientRect();
                    let rootRect = this.$refs["componentsRoot"].getBoundingClientRect();
                    //定位
                    this.valuesCardStyle = {
                        left: (targetRect.left - rootRect.left) + "px",
                        top: (20 + 32)  + "px"
                    }
                    
                    //应当展示的是其他card
                    this.showValues(this.showingConditionKey);
                }
                
            }
        },
        //显示过滤条件列表
        //属性名列表
        //showConditionCard
        showConditions(e) {
            //初始化样式
            let currentRect = e.target.getBoundingClientRect();
            let rootRect = this.$refs["componentsRoot"].getBoundingClientRect();

            //窗口定位
            this.conditionsCardStyle.left = (currentRect.left - rootRect.left) + "px";
            this.conditionsCardStyle["top"] = 32  + "px";

            //显示过滤条件card
            this.showConditionsCard = true;

            //标记有card正在显示
            this.hasCardShowing = true;

        },
        //选择过滤条件
        chooseCondition(key,condition) {

            //关闭所有card
            this.closeAllCard();

            //状态修改为被选中
            condition.selected = true;
            //修改结果集
            //TODO 该部分后期需要封装成对应的方法，根据condition类型不同，进行不同的封装
            this.resultMap[key] = {
                "tag":condition.label + ": ",
                "values":[]
            }
            //选中之后，接下来点击input要显示的应该为值card
            this.conditionOrValue = 1;
            //将要显示的条件的key
            this.showingConditionKey = key;

            //移动x轴滚动条
            this.$refs["lineScroll"].wrap.scrollLeft = this.$refs["categorySearchInputDiv"].offsetLeft;
            //显示values Card

            //延时 处理values card的定位并显示
            setTimeout(()=>{
                //处理values card 定位
                let keyWordInputRect = this.$refs["keyWordInput"].getBoundingClientRect();
                let rootRect = this.$refs["componentsRoot"].getBoundingClientRect();
                this.valuesCardStyle = {
                    left: (keyWordInputRect.left - rootRect.left) + "px",
                    top: 32 + "px"
                };
                this.showValues(key);
            },100)
            
        },
        //showValuesCard
        showValues(key) {
            this.hasCardShowing = true;
            //获取condition
            let condition = this.conditionMap[key];
            //获取condition类别，再根据condition类别显示不同类型的窗口
            //
            switch(condition.type) {
                case "check" :
                    this.showValuesCheck(condition);
                    break;
                default:
                    break;
            }
        },
        //显示check类型card
        showValuesCheck(condition) {
            //标题
            this.valuesCheckTableTitle = condition.label
            //
            this.valuesCheckTableData = condition.options;

            //

            //this.$refs.valuesCheckTable.clearSelection() 
            this.$nextTick(()=>{
                //this.$refs.valuesCheckTable.clearSelection() 
                for(let index in this.valuesCheckTableData) {
                    let option = this.valuesCheckTableData[index]
                    //此处的option为对象
                    if(option.selected === true) {
                            this.$refs.valuesCheckTable.toggleRowSelection(option,true);
                        
                    }
                }
            });
            //显示
            this.showValuesCheckCard = true;
        },
        //单选
        selectValuesCheck(rows,row) {
            let selected = rows.length > 0 && rows.indexOf(row) !== -1;
            row.selected = selected;
        },
        //全选
        selectAllValuesCheck(rows) {
            let selectAll = rows.length == this.valuesCheckTableData.length
            for(let i = 0; i < this.valuesCheckTableData.length; i ++) {
                this.valuesCheckTableData[i].selected = selectAll;
            }
        },

            
        //确定键为key的condition的值
        confirmValues() {

            let key = "";
            
            if(this.changingConditionKey !== "") {
                //如果是修改
                key = this.changingConditionKey;
            } else {
                key = this.showingConditionKey;
            }

            //当前正在显示的condition
            let currentCondition = this.conditionMap[key];
            let conditionType = currentCondition.type;

            switch(conditionType) {
                case "check": 
                    this.confirmValuesCheck(currentCondition);
                    break;
                default:
                    break;
            }

            //关闭所有card
            this.closeAllCard();

            this.$refs.valuesCheckTable.clearSelection();
            //
            setTimeout(()=>{
                //移动x轴滚动条
                this.$refs["lineScroll"].wrap.scrollLeft = this.$refs["categorySearchInputDiv"].offsetLeft;
            },100)
        },
        //处理check（复选）结果
        confirmValuesCheck(condition) {
            
            let key = "";
            
            if(this.changingConditionKey !== "") {
                //如果是修改
                key = this.changingConditionKey;
            } else {
                key = this.showingConditionKey;
            }


            let options = condition.options;
            let values = [];
            let tagStr =condition.label + ": ";

            //处理选中的值
            for(let index in options) {
                let option = options[index];
                if(option.selected === true) {
                    //添加value
                    values.push(option.value);
                    if(values.length === 1) {
                        tagStr = tagStr + " " + option.label;
                    } else {
                        tagStr = tagStr + " | " + option.label;
                    }
                }
            }

            //存放在结果map中
            this.resultMap[key] = {
                values:values,
                tag:tagStr
            };

            if(this.changingConditionKey !== "") {
                this.changingConditionKey = "";
            } else {
                //选中之后，状态回归最初
                this.conditionOrValue = 0;//接下来点击输入框应弹出的是condition card
                this.showingConditionKey = "";//正在展示的条件key为"",继续选择condition
            }
            
            
        },
        //关闭/隐藏所有Card
        closeAllCard() {
            this.showConditionsCard = false;

            this.showValuesCheckCard = false;
            this.changingConditionKey = "";
            

            this.hasCardShowing = false;
        },
        //删除Tag
        deleteTag(key) {
            
            this.closeAllCard();

            //如果结果集中包含key
            if(key in this.resultMap) {
                //从结果集中删除对应的结果
                //this.$delete => Vue.delete
                //用于解决无法监听js delete
                this.$delete(this.resultMap,key)
            }
            //如果条件中包含key
            if(key in this.conditionMap) {
                //将对应条件的selected属性设置为false
                this.conditionMap[key].selected = false;
                //并将选中的结果的selected设置为false
                let options = this.conditionMap[key].options;
                for(let index in options) {
                    //将选中的结果重置为false
                    options[index].selected = false;
                }

            }

            if(key === this.showingConditionKey) {
                this.conditionOrValue = 0;
                this.showingConditionKey = "";
            }
        },
        //处理关键字
        handleKeyWord() {
            //如果关键词不为""
            //添加标签
            if(this.keyWord !== "") {
                this.resultMap["keyWord"] = {
                    "tag":"关键字: " + this.keyWord,
                    "values":[this.keyWord]
                }
                this.keyWord = "";
            } else {
                //如果为"" 搜索
                this.searchInfo();
            }
        },
        //点击tag
        clickTag(e,key) {
            if(key === "keyWord") {
                this.keyWord = this.resultMap[key].values[0];
                this.$refs["keyWordInput"].focus();
            }
            if(this.hasCardShowing) {
                //如果有card在显示，关闭所有card
                this.closeAllCard();
            } else {
                //被点击的key
                //正在被改变的key
                this.changingConditionKey = key;
                let currentRect = e.target.getBoundingClientRect();
                let rootRect = this.$refs["componentsRoot"].getBoundingClientRect()
                //定位
                this.valuesCardStyle = {
                    left: (currentRect.left - rootRect.left) + "px",
                    top: 32+"px"
                }
                //显示
                this.showValues(key);
            }
            
        },
        searchInfo() {
            this.$emit("search",this.resultMap)
        }
        //
        // showTagValues(key) {
        //     this.hasCardShowing = true;
        //     //获取condition
        //     let condition = this.conditionMap[key];
        //     //获取condition类别，再根据condition类别显示不同类型的窗口
        //     //
        //     switch(condition.type) {
        //         case "check" :
        //             this.showTagValuesCheck(condition);
        //             break;
        //         default:
        //             break;
        //     }
        // },
        // showTagValuesCheck(condition) {
        //     //标题
        //     this.valuesCheckTableTitle = condition.label
        //     //
        //     this.valuesCheckTableData = condition.options;

        //     //
        //     this.$nextTick(()=>{
        //         //this.$refs.valuesCheckTable.clearSelection() 
        //         for(let index in this.valuesCheckTableData) {
        //             let option = this.valuesCheckTableData[index]
        //             //此处的option为对象
        //             if(option.selected === true) {
        //                     this.$refs.valuesCheckTable.toggleRowSelection(option,true);
                        
        //             }
        //         }
        //     });
        //     this.showValuesCheckCard = true;
        // }

    },
    mounted() {
        //监听鼠标点击
        document.addEventListener('click', () => {
            //点击关闭所有card
            this.closeAllCard();
        })  
    },
    computed: {
        //未被选中的condition map
        unSelectedConditionMap() {
            let unSelectedConditionMap = {};
            //遍历
            for(let key in this.conditionMap) {
                //获取condition
                let condition = this.conditionMap[key];
                //判断未选中的condition
                if(condition.selected === false) {
                    unSelectedConditionMap[key] = condition;
                }
            }
            
            return unSelectedConditionMap;
        }
    },
    // 在组件生命周期结束时销毁
    beforeDestroy() {
      window.removeEventListener('click', () => {}, true)
    }
}
</script>

<style>
*,*::before,*::after {
    box-sizing: border-box;
}
a,a:hover,a:focus,a:active,a:visited {
    text-decoration: none;
}
ul,ol {
    list-style: none;
    margin: 0;
    padding: 0;
}
.category-search {
    position: relative;
}
.category-search-container {
    position: relative;

    width: 100%;
    height: 32px;
    padding: 0 8px;
    border: 1px solid #D7D8DA;
    border-radius: 4px;
    background: transparent;
    background-color: #FFFFFF;

    display: flex;
    align-items: flex-start;

    transition: border .3s cubic-bezier(.645, .045, .355, 1);
}
.category-search-icon-container {

    height: 30px;
    padding-right: 8px;

    display: flex;
    align-items: center;

}
.category-search-icon {
    width: 16px;
    height: 16px;
    cursor: pointer;
}
.category-search-line-container {
    width: 100%;
    height: 32px;
    overflow: hidden;
}
.category-search-line {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 30px;
    top: -1px;
}
.category-search-line li {
    display: flex;
    align-items: center;
    flex-grow: 0;
    white-space: nowrap;
    height: 100%;
}
.category-search-tag-item {
    margin-right: 4px;
    position: relative;
    vertical-align: middle;
}
.category-search-tag-item:first-child {
    margin-left: 4px;
}
.category-search-tag-container {
    font-size: 12px;
    background-color: #E9EDFA;
    display: inline-block;
    position: relative;
}
.category-search-tag {
    /* display: block !important; */
    display: inline-block;
    
    padding: 0 4px 0 5px;
    min-height: 20px;
    font-size: 12px;
    line-height: 20px;
    color: #71757f;
    background-color: #E9EDFA;
    border-radius: 2px;
    border-width: 0;
    border-style: solid;
    border-color: inherit;
    align-items: center;
    position: relative;
    cursor: default;
}
.category-search-tag > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    vertical-align: bottom;
    margin: 0 2px;
}
.category-search-tag-remove {
    margin-right: 4px;
    font-size: 14px;
    font-weight: lighter;
    color: #FFFFFF;
    cursor: pointer;
    width: 12px;
    height: 12px;
    line-height: 12px;
    background-color: #D7D8DA;
    border-radius: 50%;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    transition: background-color cubic-bezier(.645, .045, .355, 1) .3s;
}
.category-search-tag-remove:hover {
    background-color: #bbbbbb;
    color: #FFFFFF;
}
.category-search-input {
    display: flex;
    justify-content: flex-start;
    flex-grow: 1;
    align-items: center;
    min-width: 240px;
    padding-right: 20px;
}
.category-search-input-container {
    display: flex;
    flex: 1;
    position: relative;
    vertical-align: middle;
}
.category-search-input input {
    padding-left: 0;
    min-width: 240px;
    width: 100%;
    height: 32px;
    font-size: 12px;
    border: none;
    background-color: transparent;
    box-shadow: none;
    border-radius: 2px;
    outline: none !important;
    padding: 4px 8px;
    color: #252B3A;
    vertical-align: middle;
    overflow: visible;
    line-height: 1.5;
    margin: 0;
}
/** conditions card */
.conditions-card-show {
    position: absolute;
    max-height: 300px;
    min-width: 160px;
    max-width: 300px;
    z-index: 1000;
    overflow: auto;
    transition: max-height 0.3s linear !important;/*,border 0.3 ease*/
}
.conditions-card-close {
    position: absolute;
    max-height: 0px;
    min-width: 160px;
    max-width: 300px;
    overflow: hidden;
    border: none !important;
    transition: max-height 0.3s linear,border 0.3 linear !important;
}
.conditions-container .el-scrollbar > .el-scrollbar__wrap {
    max-height: 260px;
    overflow-x:hidden;  
}
.conditions-container {
    max-height: 260px;
}

.condition-item {
    height: 26px;
    line-height: 26px;
    padding-left: 5px;
    text-align: left;
    padding-bottom: 3px;
    /* border-bottom: 0.5px solid #DADADA; */
    margin-bottom: 3px;
    cursor: pointer;
}
.condition-item:last-child {
    margin-bottom: 26px;
}
.condition-item:hover {
    background-color: #EAEAEA;
}

.values-check-card-show {
    position: absolute;
    max-height: 300px;
    min-width: 160px;
    max-width: 350px;
    z-index: 1000;
    overflow: auto;
    transition: max-height 0.3s linear !important;/*,border 0.3 ease*/
}
.values-check-card-close {
    position: absolute;
    max-height: 0px;
    min-width: 160px;
    max-width: 350px;
    overflow: hidden;
    border: none !important;
    transition: max-height 0.3s linear,border 0.3 linear !important;
}
/** el table 滑动条 美化 */
.el-table__body-wrapper::-webkit-scrollbar {
    width: 6px; /*横向滚动条*/
    height: 6px; /*纵向滚动条 必写*/
  }

.el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #ddd;
    border-radius: 3px;
  }
</style>